import a from "./td-longtail-vue-components268.js";
/* empty css                              */
import r from "./td-longtail-vue-components98.js";
var l = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.LinkButton, t._b({ directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: n.openable.onClickaway, expression: "openable.onClickaway" }], ref: "buttonElement", class: n.containerClass, attrs: { tag: t.button?.tag || "button", type: t.button?.type || "button" }, on: { click: n.click }, nativeOn: { mouseover: function(o) {
    return n.mouseOver.apply(null, arguments);
  }, mouseleave: function(o) {
    return n.mouseLeave.apply(null, arguments);
  }, focus: function(o) {
    return n.onFocus.apply(null, arguments);
  }, blur: function(o) {
    return n.onBlur.apply(null, arguments);
  } } }, "LinkButton", t.button, !1), [e("span", { ref: "tooltipElement", staticClass: "tooltip-container", class: `tooltip-container--${n.tooltipPosition}`, attrs: { role: "tooltip", "aria-hidden": t.innerAriaHidden ? "true" : "false" } }, [e("span", { domProps: { innerHTML: t._s(t.text) } })]), t._t("default")], 2);
}, s = [], i = /* @__PURE__ */ r(
  a,
  l,
  s,
  !1,
  null,
  "6a7dc21f"
);
const f = i.exports;
export {
  f as default
};
